import { TEditModifierGroupsAction, EditModifierGroupsActionTypes } from './editModifierGroupsActions';
import { IEditModifierGroupsState } from './editModifierGroupsContext';

export const editModifierGroupsReducer = (
	state: IEditModifierGroupsState,
	action: TEditModifierGroupsAction,
): IEditModifierGroupsState => {
	switch (action.type) {
		case EditModifierGroupsActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
			};
		case EditModifierGroupsActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditModifierGroupsActionTypes.SET_ALL_DATA:
			return {
				...state,
				modifierGroupsID: action.payload.modifierGroupsID,
				initialIDSelectedCustomer: action.payload.initialIDSelectedCustomer,
				initialIDsSelectedRestaurant: action.payload.initialIDsSelectedRestaurant,
				IDsIsForceDisabledRestaurant: action.payload.IDsIsForceDisabledRestaurant,
				initialIDsSelectedCategories: action.payload.initialIDsSelectedCategories,
				initialIDsSelectedSubcategories: action.payload.initialIDsSelectedSubcategories,
				initialIDsSelectedDishes: action.payload.initialIDsSelectedDishes,
				nameOfModifierGroup: action.payload.nameOfModifierGroup,
				modifiersOfModifierGroups: action.payload.modifiersOfModifierGroups,
				externalId: action.payload.externalId,
				articleNumber: action.payload.articleNumber,
				translations: action.payload.translations,
			};
		case EditModifierGroupsActionTypes.CHANGE_LOADER_STATUS:
			return {
				...state,
				isLoading: action.payload.isLoading,
			};
		case EditModifierGroupsActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditModifierGroupsActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.customers,
			};
		case EditModifierGroupsActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				fetchedCategories: [],
				IDsSelectedCategories: [],
				IDsSelectedSubcategories: [],
				fetchedDishes: [],
				IDsSelectedDishes: [],
				defaultCustomerLanguage: null,
			};
		case EditModifierGroupsActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case EditModifierGroupsActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
				IDsIsForceDisabledRestaurant: action.payload.IDsIsForceDisabledRestaurant,
			};
		case EditModifierGroupsActionTypes.SET_IDS_IS_FORCE_DISABLED_RESTAURANT:
			return {
				...state,
				IDsIsForceDisabledRestaurant: action.payload.IDsIsForceDisabledRestaurant,
			};
		case EditModifierGroupsActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.fetchedCategories,
			};
		case EditModifierGroupsActionTypes.SET_IDS_CATEGORIES:
			return {
				...state,
				IDsSelectedCategories: action.payload.IDsSelectedCategories,
			};
		case EditModifierGroupsActionTypes.SET_FETCHED_SUBCATEGORIES:
			return {
				...state,
				fetchedSubcategories: action.payload.fetchedSubcategories,
			};
		case EditModifierGroupsActionTypes.SET_IDS_SUBCATEGORIES:
			return {
				...state,
				IDsSelectedSubcategories: action.payload.IDsSelectedSubcategories,
			};
		case EditModifierGroupsActionTypes.SET_FETCHED_DISHES:
			return {
				...state,
				fetchedDishes: action.payload.dishes,
			};
		case EditModifierGroupsActionTypes.SET_IDS_DISHES:
			return {
				...state,
				IDsSelectedDishes: action.payload.IDsSelectedDishes,
			};
		case EditModifierGroupsActionTypes.CHANGE_NAME_OF_MODIFIER_GROUP:
			return {
				...state,
				nameOfModifierGroup: action.payload.nameOfModifierGroup,
			};
		case EditModifierGroupsActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case EditModifierGroupsActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE:
			return {
				...state,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case EditModifierGroupsActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case EditModifierGroupsActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case EditModifierGroupsActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditModifierGroupsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditModifierGroupsActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case EditModifierGroupsActionTypes.RESET_FIELDS:
			return {
				...state,
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				IDsIsForceDisabledRestaurant: [],
				fetchedCategories: [],
				IDsSelectedCategories: [],
				IDsSelectedSubcategories: [],
				fetchedDishes: [],
				IDsSelectedDishes: [],
				nameOfModifierGroup: '',
				externalId: '',
				articleNumber: null,
				modifiersOfModifierGroups: [],
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
				errorResponseData: null,
			};
		default:
			return state;
	}
};
